<app-chips-container id="chips-area" [width]="width()">
  <mat-chip
    class="map-filter-chip"
    (click)="showAllFilters()"
    aria-description="Mostrar menu lateral de filtros"
    aria-label="Todos los filtros">
    <div class="chip-container">
      <span class="material-symbols-rounded">filter_list</span>
      <span>Todos los filtros</span>
    </div>
  </mat-chip>

  <app-chips-map-buttons
    #filtroTomas
    [ariaDescription]="'Mostrar solo tomas'"
    chipIcon="valve"
    chipLabel="Tomas"
    (clicked)="showOnlyTomas()"></app-chips-map-buttons>

  <app-chips-map-buttons
    #filtroHidrantes
    [ariaDescription]="'Mostrar solo hidrantes'"
    chipIcon="fire_hydrant"
    chipLabel="Hidrantes"
    (clicked)="showOnlyHidrantes()"></app-chips-map-buttons>

  <app-chips-map-buttons
    #filtroEstaciones
    [ariaDescription]="'Mostrar solo estaciones'"
    chipIcon="partly_cloudy_day"
    chipLabel="Estaciones"
    (clicked)="showOnlyEstaciones()"></app-chips-map-buttons>
</app-chips-container>
